import { render } from "./_tag-list.vue?vue&type=template&id=328a69c6&lang=pug"
import script from "./_tag-list.vue?vue&type=script&lang=js"
export * from "./_tag-list.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__